module.exports = __webpack_public_path__ + "static/media/registerBannerImage.93067704.png";